<template>
  <div class="flex" :style="style">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Flex',

  props: {
    align: {
      type: String,
      default: 'flex-start'
    },

    justify: {
      type: String,
      default: 'flex-start'
    },

    direction: {
      type: String,
      default: 'row'
    }
  },

  computed: {
    style () {
      const {
        align,
        justify,
        direction
      } = this

      return {
        alignItems: align,
        flexDirection: direction,
        justifyContent: justify
      }
    }
  }
}
</script>

<style lang="sass">
.flex
  display: flex

.align-right
  margin-left: auto
</style>
